"use strict";
// @ts-ignore
try {
    self['workbox:expiration:6.5.4'] && _();
}
catch (e) { }
